<template>
  <PageWithLayout>
    <div class="section_comm">
      <div class="section_head">
        <h2 id="kakaoBody" class="tit_section">가격안내</h2>
        <p class="desc_section">기업의 사용목적과 규모에 따라 서비스를 선택할 수 있도록 다양한 요금제를 제공합니다.</p>
      </div>
      <div class="section_body">
        <div class="list_payment">
          <!-- 스마트팩토리 -->
          <div class="item_payment module_payment">
            <h3 class="tit_payment">모듈 요금제</h3>
            <div class="body_payment">
              <div class="box_plan">
                <div class="info_plan">
                  <strong class="tit_plan">라이트</strong>
                  <div class="price_plan"><span class="txt_plan">₩ 30,000<span class="txt_unit">/월</span></span></div>
                  <p class="desc_plan">500G / 10명</p>
                </div>
                <ul class="list_plan">
                  <li><span class="ico_brand ico_check"></span>저장공간 500G</li>
                  <li><span class="ico_brand ico_check"></span>맴버 초대 기본 10명</li>
                  <li><span class="ico_brand ico_check"></span>서비스 별 개인화된 카톡 알림</li>
                  <li><span class="ico_brand ico_check"></span>모듈 기본 1개 제공</li>
                  <li><span class="ico_brand ico_check"></span>멤버 추가 1인당 월 5,000원</li>
                  <li><span class="ico_brand ico_check"></span>추가 모듈 1개당 월 30,000원</li>
                </ul>
              </div>
              <div class="box_plan">
                <div class="info_plan">
                  <strong class="tit_plan">베이직</strong>
                  <div class="price_plan"><span class="txt_plan">₩ 100,000<span class="txt_unit">/월</span></span></div>
                  <p class="desc_plan">1T / 50명</p>
                </div>
                <ul class="list_plan">
                  <li><span class="ico_brand ico_check"></span>저장공간 1T</li>
                  <li><span class="ico_brand ico_check"></span>맴버 초대 기본 50명</li>
                  <li><span class="ico_brand ico_check"></span>서비스 별 개인화된 카톡 알림</li>
                  <li><span class="ico_brand ico_check"></span>모듈 기본 1개 제공</li>
                  <li><span class="ico_brand ico_check"></span>멤버 추가 1인당 월 4,000원</li>
                  <li><span class="ico_brand ico_check"></span>추가 모듈 1개당 월 100,000원</li>
                </ul>
              </div>
              <div class="box_plan box_premium">
                <div class="info_plan">
                  <strong class="tit_plan">프리미엄</strong>
                  <div class="price_plan"><span class="txt_plan">별도 문의</span></div>
                  <p class="desc_plan">2T / 200명</p>
                  <div class="link_plan">
                    <a href="javascript:void(0)" class="link_text_g" @click="moveInquiry">
                      <span class="txt_item">문의하기</span>
                    </a>
                  </div>
                </div>
                <ul class="list_plan">
                  <li><span class="ico_brand ico_check"></span>저장공간 2T</li>
                  <li><span class="ico_brand ico_check"></span>맴버 초대 기본 200명</li>
                  <li><span class="ico_brand ico_check"></span>서비스 별 개인화된 카톡 알림</li>
                  <li><span class="ico_brand ico_check"></span>모듈 기본 1개 제공</li>
                  <li><span class="ico_brand ico_check"></span>멤버 추가 시, 별도 문의</li>
                  <li><span class="ico_brand ico_check"></span>추가 모듈 1개당 별도 문의</li>
                </ul>
              </div>
              <p class="desc_tip"><span class="ico_brand ico_exclam"></span>모든 요금은 VAT 별도입니다.</p>
            </div>
          </div>
          <div class="item_payment delivery_payment">
            <h3 class="tit_payment">콜드체인 요금제</h3>
            <div class="body_payment">
              <div class="box_plan">
                <div class="info_plan">
                  <strong class="tit_plan">라이트</strong>
                  <div class="price_plan"><span class="txt_plan">₩ 50,000<span class="txt_unit">/월</span></span></div>
                  <p class="desc_plan">500G / 10대</p>
                </div>
                <ul class="list_plan">
                  <li><span class="ico_brand ico_check"></span>저장공간 500G</li>
                  <li><span class="ico_brand ico_check"></span>차량 추가 기본 10대</li>
                  <li><span class="ico_brand ico_check"></span>차량 추가 1대당 월 5,000원</li>
                </ul>
              </div>
              <div class="box_plan">
                <div class="info_plan">
                  <strong class="tit_plan">베이직</strong>
                  <div class="price_plan"><span class="txt_plan">₩ 400,000<span class="txt_unit">/월</span></span></div>
                  <p class="desc_plan">1T / 100대</p>
                </div>
                <ul class="list_plan">
                  <li><span class="ico_brand ico_check"></span>저장공간 1T</li>
                  <li><span class="ico_brand ico_check"></span>차량 추가 기본 100대</li>
                  <li><span class="ico_brand ico_check"></span>차량 추가 1대당 월 4,000원</li>
                </ul>
              </div>
              <div class="box_plan">
                <div class="info_plan">
                  <strong class="tit_plan">프리미엄</strong>
                  <div class="price_plan"><span class="txt_plan">₩ 700,000<span class="txt_unit">/월</span></span></div>
                  <p class="desc_plan">2T / 200대</p>
                </div>
                <ul class="list_plan">
                  <li><span class="ico_brand ico_check"></span>저장공간 2T</li>
                  <li><span class="ico_brand ico_check"></span>차량 추가 기본 200대</li>
                  <li><span class="ico_brand ico_check"></span>차량 추가 1대당 월 3,500원</li>
                </ul>
              </div>
              <p class="desc_tip"><span class="ico_brand ico_exclam"></span>모든 요금은 VAT 별도입니다.</p>
            </div>
          </div>
          <div class="item_payment">
            <h3 class="tit_payment">모듈 선택 <span class="txt_tip">중복선택 가능</span></h3>
            <div class="body_payment">
              <div class="area_option">
                <div class="box_module">
                  <strong class="tit_module">업무</strong>
                  <p class="desc_module">이슈를 등록하여 담당자에게 이슈를 공유하고 이력을 관리 할 수 있는 서비스</p>
                </div>
                <div class="box_module">
                  <strong class="tit_module">알람</strong>
                  <p class="desc_module">시스템 알람 기반으로 담당자에게 알람 및 진행사항을 공유할 수 있는 서비스</p>
                </div>
                <div class="box_module">
                  <strong class="tit_module">인포</strong>
                  <p class="desc_module">외부 시스템과의연동을 통하여 공정 현황을 관리하고 모니터링을 할 수 있는 서비스</p>
                </div>
                <div class="box_module">
                  <strong class="tit_module">문서</strong>
                  <p class="desc_module">표준화된 문서작성 기능을 통하여 다양한 형태 작업보고서를 작성하고 관리할 수 있는 서비스</p>
                </div>
                <div class="box_module">
                  <strong class="tit_module">콜드체인</strong>
                  <p class="desc_module">운송 현황 데이터 저장 및 실시간 모니터링이 가능하며, 이상 데이터 감지 시 카카오톡으로 알림 발송이되는 서비스</p>
                </div>
                <div class="box_module">
                  <strong class="tit_module">클러스터</strong>
                  <p class="desc_module">협력업체와 구매/발주 및 재고 정보를 공유하여 공정 프로세스의 원활한 유지가 가능한 서비스</p>
                  <span class="tag_g"><span class="txt_item">오픈예정</span></span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="item_payment">
            <h3 class="tit_payment">월 요금 계산하기</h3>
            <div class="body_payment">
              <div class="box_calc">
                <div class="area_calc">
                  <dl class="dl_list">
                    <dt>요금제 선택</dt>
                    <dd>
                      <div class="select_comm">
                        <div class="selectbox_g">
                          <tooltip-menu :list="plan" v-model="planType" @change="clickPlanSelect">
                            <template v-slot:activator="{on, title}">
                              <strong class="screen_out">문의 분류 선택상자</strong>
                              <button type="button" class="btn_select" v-on="on">
                                {{title}}
                                <span class="screen_out">선택됨</span><span class="ico_brand ico_select">옵션보기</span>
                              </button>
                            </template>
                          </tooltip-menu>
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="dl_list dl_check">
                    <dt>서비스 모듈 선택</dt>
                    <dd>
                      <Checkbox
                          :dataList="moduleDataList"
                          :checkedNames.sync="setModuleList"
                      />
                    </dd>
                  </dl>
                  <dl class="dl_list dl_personnel">
                    <dt>추가인원입력</dt>
                    <dd>
                      <div class="box_count" :class="{'_disbled' : isPremium}">
                        <button :disabled="countofPerson == 0 || isPremium" @click="subPerson" class="btn_minus"><span class="ico_brand ico_minus">-</span></button>
                        <span class="txt_count">{{countofPerson}}</span>
                        <button :disabled="isPremium" @click="addPerson" class="btn_plus"><span class="ico_brand ico_plus">+</span></button>
                        <a href="javascript:void(0)" class="link_text_g" v-if="isPremium" @click="moveInquiry">
                          <span class="txt_item">문의하기</span><span class="ico_brand ico_arrow_r"></span>
                        </a>

                      </div>
                    </dd>
                  </dl>
                </div>
                <div class="result_calc">
                  <ul class="list_tag">
                    <li>{{planType.label}}</li>
                    <li v-for="(item, index) in moduleList" :key="index">{{item.text}}</li>
                    <li v-if="Number(countofPerson) > 0">{{countofPerson}}명</li>
                  </ul>
                  <div class="info_total">
                    <strong class="tit_total">총 이용요금 (부가세별도)</strong>
                    <span class="txt_total">₩ {{totalfee | commaString}}<span class="txt_unit"> / 월</span></span>
                    <button @click="resetFomulation" class="btn_refresh"><span class="ico_brand ico_refresh"></span>다시 계산하기</button>
                  </div>
                </div>
              </div>
              <div class="desc_tip_bundle">
                <p class="desc_tip"><span class="ico_brand ico_exclam"></span>모든 요금은 사용하시는 모듈 수에 따라 부과됩니다.</p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </PageWithLayout>
</template>
<script>
import PageWithLayout from '@/components/layout/PageWithLayout';
import Checkbox from '@/components/common/checkbox/Checkbox';
import CheckboxOnlyOne from '@/components/common/checkbox/CheckboxOnlyOne';
import TooltipMenu from "@/components/common/tooltip/TooltipMenu";
import TiaraService from "@/plugins/TiaraService";
const tiaraService = TiaraService.getService();

export default {
  name: 'CostInfo',
  components: {
    PageWithLayout,
    // Checkbox,
    // CheckboxOnlyOne,
    // TooltipMenu
  },
  data(){
    return{
      totalCost : 0,        // 총 금액
      countofPerson : 0,    // 추가인원
      isCheckAll : false,
      moduleDataList:[      // 서비스 모듈
        {text:'업무', id:'businessModule'},
        {text:'알람', id:'alarmModule'},
        {text:'인포', id:'infoModule'},
        {text:'문서', id:'documentModule'},
      ],
      moduleList : [
        {text:'업무', id:'businessModule'}
      ],  // 선택한 서비스 모듈
      plan: [           // 요금제
        {label: '라이트', code: 'light', cost: 30000},
        {label: '베이직', code: 'basic', cost : 100000},
        {label: '프리미엄', code: 'premium', cost: 200000 },
      ],
      planType: {label: '라이트', code: 'light', cost: 30000},   // 선택한 요금제
      period: [         // 결제 기간
        {label: '1개월', code: 1, discount : 0},
        {label: '6개월', code: 6, discount : 0.5},
        {label: '12개월', code: 12, discount : 0.1},
        {label: '24개월', code: 24, discount : 0.2},
      ],
      periodType: {label: '1개월', code: 1, discount : 0},     // 선택결제기간
      lightPlan : {
        month : 30000,
        member : 5000,
        module : 30000
      },
      basicPlan : {
        month : 100000,
        member : 4000,
        module : 100000
      },
      premiumPlan : {
        month : 200000,
        member : 0, // 별도문의
        module : 200000
      },

    }
  },
  mounted() {
    // console.log('mounted')
    tiaraService.trackPage('가격안내');
  },
  computed: {
    totalfee: {
      get(){
        if(!this.validation()){
          return 0;
        }
        else {
          return this.costFomulation();
        }
      },

    },
    setModuleList : {
      get(){
        return this.moduleList
      },
      set(value){

        if(this.isCheckAll){
          this.isCheckAll = false;
        }
        if(value.length === this.moduleDataList.length) {
          this.isCheckAll = true;
        }
        this.moduleList = value
      }
    },
    checkAll: {
      get(){
        return this.isCheckAll
      },
      set(value){
        this.isCheckAll = !this.isCheckAll;
        this.moduleList = [];
        if(this.isCheckAll){
          for(var key in this.moduleDataList){
            this.moduleList.push( this.moduleDataList[key] )
          }
        }else {
          this.moduleList = [];
        }


      }
    },
    isPremium() {
      return this.planType.code === 'premium';
    }
  },
  methods: {
    moveInquiry() {
      this.$router.push( { name: 'Inquire' } );
    },

    clickPlanSelect(value) {
      this.planType = value;
      if(value.code === 'premium') {
        this.countofPerson = 0;
      }
    },
    clickPeriodSelect(value) {
      this.periodType = value;
    },
    resetFomulation(){
      // 선택한 서비스모듈 초기화
      this.moduleList = [
        {text:'업무', id:'businessModule'}
      ];

      // 모두선택 체크 해제
      this.isCheckAll = false;

      // 요금제 초기화
      this.planType = this.plan[0]

      // 기간 초기화
      this.periodType = this.period[0]

      // 인원 초기화
      this.countofPerson = 0;
    },
    validation(){
      if(!this.planType.length == 0){
        return false;
      }
      // if(this.moduleList.length == 0){
      //   return false;
      // }
      // if(this.countofPerson == 0){
      //   return false;
      // }
      if(this.periodType.length == 0){
        return false;
      }
      return true;
    },
    costFomulation(){
      // 총 이용요금
      var total = 0;

      // 요금제선택
      var plan = this.planType.code
      if(plan == 'light'){
        plan = this.lightPlan // 라이트
      }else if(plan == 'basic'){
        plan = this.basicPlan // 베이직
      }else{
        plan = this.premiumPlan // 프리미엄
      }

      // 요금제 월 금액
      const month = plan.month

      // 모듈
      var moduleFee = 0;
      if(this.moduleList.length > 1){
        moduleFee = plan.module * (this.moduleList.length - 1)// 1개 이상인 경우 요금 추가
      }
      // 기간
      const period = this.periodType.code

      // 기간별 할인율
      const discount = this.periodType.discount

      // 인원 추가에 따른 요금 추가 (프리미엄 제외)
      const person = this.countofPerson * plan.member

      // 20.10.16 월단위 요금으로 변경
      return total = ((month + moduleFee + person))

      // 총 계산 금액 (기본*기간+모듈+인원추가) * 기간별 할인율
      // return total = ((month + moduleFee + person) * period ) * (1 - discount)
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    addPerson(){
      this.countofPerson += 1;
    },
    subPerson(){
      this.countofPerson -= 1;
    }
  }
}
</script>
